import { I18n } from '@aws-amplify/core';
import { DatePicker, Form } from 'antd';
import React from 'react';

type CollectionDateSelectProps = {
	organizationId: string;
	companyId: string;
};

export function CollectionDateSelect({ organizationId, companyId }: CollectionDateSelectProps) {
	return (
		<Form.Item label={I18n.get('Collection date')} name="collectionDate">
			<DatePicker.RangePicker
				disabled={!organizationId || !companyId}
				showTime={{ format: 'HH:mm:00' }}
				format="DD-MM-YYYY HH:mm:00"
				style={{ width: '100%' }}
			/>
		</Form.Item>
	);
}
